<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
  <p>{{data.message}}</p>
</div>
<div mat-dialog-actions>
  <button *ngIf="data.cancelButtonText" mat-flat-button [mat-dialog-close]="false">{{data.cancelButtonText}}</button>
  <button mat-flat-button color="accent" [mat-dialog-close]="true" cdkFocusInitial>{{data.okButtonText}}</button>
</div>
